import React, {useEffect, useMemo, useRef, useState} from 'react';

import {
    Col,
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    Row,
    UncontrolledDropdown,
    Card,
    CardHeader,
    CardBody,
    Alert,
} from 'reactstrap';

import SimpleBar from "simplebar-react";
import logoWhite from "../assets/images/Project/hrplus-white.png";

// Toast Container
import 'react-toastify/dist/ReactToastify.css';
import {toast} from 'react-toastify';
import {useDispatch} from 'react-redux';
import {useTranslation} from 'react-i18next';

const Chat = () => {
    const {t} = useTranslation();

    const initialMessages = [
        {id: -1, message: t('t-good-day'), replaid_to: 0, from: 1, created_time: new Date()},
        {id: 0, message: t('t-we-are-online'), replaid_to: 0, from: 1, created_time: new Date()},
    ];

    const dispatch = useDispatch();

    const [messages, setMessages] = useState(initialMessages);
    const [show, setShow] = useState(false);
    const [text, setText] = useState('');
    const [userId, setUserId] = useState(localStorage.getItem('hrUserId'));
    const [showCopyAlert, setShowCopyAlert] = useState(false); // Nusxa olish alerti uchun alohida state
    const [unreadCount, setUnreadCount] = useState(0); // O'qilmagan xabarlar soni

    const intervalRef = useRef(null);
    const lastMessId = useRef(0);

    const toggle = () => {
        setShow(prev => {
            if (!prev) {
                makeMessageRead();
                setUnreadCount(0);
            }
            return !prev;
        });
    };

    useEffect(() => {
        const fetcherMessages = async (interval = false) => {
            let resp = await fetch('https://online.hrplus.uz/get-advert-chat-message', {
                method: "POST",
                headers: {
                    "Content-type": "application/json",
                    "login": 'HRplus+',
                    "password": 'Ctc0oTYayc77z',
                },
                body: JSON.stringify({
                    user_id: +userId,
                    type: 0,
                    interval: interval,
                    start: +lastMessId.current,
                }),
            })
                .then(resp => resp.json())
                .catch(err => {
                    console.log(err);
                });

            if (resp && resp['messages'] && resp['messages'].length) {
                setMessages(state => {
                    return [...state, ...resp['messages']];
                });

                if (!show && interval) {
                    const newMessagesCount = resp['messages'].filter(msg => msg.from === 1).length;
                    if (newMessagesCount > 0) {
                        setUnreadCount(prev => prev + newMessagesCount);
                    }
                }

                lastMessId.current = resp['messages'][resp['messages'].length - 1]['id'];
                scrollToBottom();
            }

            if (!interval) {
                intervalRef.current = setInterval(() => {
                    fetcherMessages(true);
                    console.log(lastMessId.current);
                }, 2 * 1000);
            }
        }

        if (userId) {
            fetcherMessages();
        }

        return () => {
            if (intervalRef.current)
                clearInterval(intervalRef.current);
        }

    }, [userId, show]);

    const sendMessage = async () => {
        if (text.trim()) {
            let body = {
                message: text,
                user_id: localStorage.getItem('hrUserId'),
            };
            fetch('https://online.hrplus.uz/send-advert-chat-message', {
                method: "POST",
                headers: {
                    "Content-type": "application/json",
                    "login": 'HRplus+',
                    "password": 'Ctc0oTYayc77z',
                },
                body: JSON.stringify(body),
            })
                .then(resp => resp.json())
                .then(resp => {
                    if (!resp['status'])
                        return toast.error(t('t-server-error'))
                    setMessages(state => {
                        return [...state, resp['message']]
                    });
                    lastMessId.current = resp['message']['id'];

                    if (!userId) {
                        localStorage.setItem('hrUserId', resp['id']);
                        setUserId(resp['id']);
                    }
                    setText('');
                    scrollToBottom();
                })
                .catch(err => {
                    console.log(err);
                });
        }
    }

    const onKeyUp = e => {
        if (e.key === 'Enter')
            sendMessage();
    }

    const changeHandler = e => {
        setText(e.target.value);
    }

    // Scroll to Bottom
    function scrollToBottom() {
        setTimeout(function () {
            var simpleBar = document.querySelector(".chat-conversation .simplebar-content-wrapper");
            if (simpleBar) {
                var offsetHeight = document.querySelector(".chat-conversation .simplebar-content-wrapper").scrollHeight;
                if (offsetHeight)
                    simpleBar.scrollTo({
                        top: offsetHeight,
                        behavior: "smooth",
                    });
            }
        }, 100);
    }

    const copyMessage = async (message) => {
        try {
            await navigator.clipboard.writeText(message);
            setShowCopyAlert(true);
            setTimeout(() => {
                setShowCopyAlert(false);
            }, 2000);
        } catch (err) {
            // Fallback eski usul
            const textArea = document.createElement("textarea");
            textArea.value = message;
            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select();
            try {
                document.execCommand('copy');
                setShowCopyAlert(true);
                setTimeout(() => {
                    setShowCopyAlert(false);
                }, 2000);
            } catch (err) {
                toast.error(t('t-copy-error') || 'Nusxa olishda xatolik');
            }
            document.body.removeChild(textArea);
        }
    }

    const deleteMessage = async (id) => {
        let result = await fetch('https://online.hrplus.uz/delete-advert-messages?id=' + id + '&status=' + 0, {
            method: "DELETE",
            headers: {
                "Content-type": "application/json",
                "login": 'HRplus+',
                "password": 'Ctc0oTYayc77z',
            },
        })
            .then(resp => resp.json())
            .catch(err => console.log(err));

        if (result && result.status) {
            setMessages(state => {
                let newState = [...state];
                newState = newState.filter(val => val['id'] !== id);
                return newState;
            });
        }
    }

    const makeMessageRead = () => {
        if (userId) {
            fetch('https://online.hrplus.uz/make-advert-messages-read?unread=1&user_id=' + userId, {
                method: "GET",
                headers: {
                    "Content-type": "application/json",
                    "login": 'HRplus+',
                    "password": 'Ctc0oTYayc77z',
                },
            })
                .then(resp => resp.json())
                .then(resp => {
                    if (resp && resp.status) {
                        console.log('Messages marked as read');
                    }
                })
                .catch(err => console.log(err));
        }
    }

    return (
        <React.Fragment>
            <div className="customizer-setting d-none d-md-block">
                {show ?
                    <button className="btn-outline-danger btn-rounded shadow-lg btn btn-icon btn-lg"
                            onClick={toggle}>
                        <i className="ri-close-line fs-2"></i>
                    </button> :
                    <button className="btn-warning btn-rounded shadow-lg btn btn-icon btn-lg position-relative"
                            onClick={toggle}
                    >
                        <i className="bx bxs-message-rounded-dots" style={{fontSize: "1.8rem"}}></i>
                        {unreadCount > 0 && (
                            <span
                                className="position-absolute translate-middle badge rounded-pill bg-danger"
                                style={{top: 3, left: 40}}
                            >
                             {unreadCount}
                                <span className="visually-hidden">unread messages</span>
                            </span>
                        )}
                    </button>
                }
                <div className={"email-chat-detail shadow-lg " + (show ? "d-block" : "d-none")}
                     id="emailchat-detailElem"
                     style={{
                         bottom: "97px",
                         right: "25px",
                         borderBottomLeftRadius: "10px",
                         borderBottomRightRadius: "10px",
                     }}>
                    <Card className="mb-0" style={{borderRadius: "10px"}}>
                        <CardHeader className="align-items-center d-flex bg-primary text-white-50 p-3"
                                    style={{borderTopRightRadius: "10px", borderTopLeftRadius: "10px"}}>
                            <div className="flex-grow-1">
                                <img src={logoWhite} className="card-logo" alt="logo" height="35"/>
                            </div>
                            <div className="flex-shrink-0">
                                <div className="me-n2">
                                    <button type="button"
                                            className="btn btn-sm btn-link text-white fs-16 text-decoration-none"
                                            id="emailchat-btn-close"
                                            onClick={toggle}
                                    >
                                        <i className="ri-close-fill"></i>
                                    </button>
                                </div>
                            </div>
                        </CardHeader>

                        <CardBody className="p-0">
                            <div id="users-chat email-chat-element">
                                <SimpleBar className="chat-conversation chatwidgets p-3 mt-0" id="chat-conversation">
                                    <ul className="list-unstyled chat-conversation-list chat-sm"
                                        id="users-conversation">
                                        {messages.map((message, index) => message['from'] ?
                                            <li className="chat-list left" key={index}>
                                                <div className="conversation-list mb-2">
                                                    <div className="user-chat-content">
                                                        <div className="ctext-wrap-content">
                                                            <p className="mb-0 fs-13">{message['message']}</p>
                                                        </div>
                                                        <div className="conversation-name my-2">
                                                            <small className="text-muted time">
                                                                {new Date(message['created_time']).toLocaleString('ru').slice(0, 17)}
                                                            </small>
                                                        </div>
                                                    </div>
                                                </div>
                                            </li> :
                                            <li className="chat-list right" key={index}>
                                                <div className="conversation-list">
                                                    <div className="user-chat-content">
                                                        <div className="ctext-wrap">
                                                            <div className="ctext-wrap-content">
                                                                <p className="mb-0 ctext-content">{message['message']}</p>
                                                            </div>
                                                            <UncontrolledDropdown
                                                                className="align-self-start message-box-drop">
                                                                <DropdownToggle tag="a" role="button">
                                                                    <i className="ri-more-2-fill"></i>
                                                                </DropdownToggle>
                                                                <DropdownMenu>
                                                                    <DropdownItem onClick={() => {
                                                                        copyMessage(message['message']);
                                                                    }}>
                                                                        <i className="ri-file-copy-line me-2  align-bottom text-primary"></i>{t('t-copy')}
                                                                    </DropdownItem>
                                                                    <DropdownItem onClick={() => {
                                                                        deleteMessage(message['id']);
                                                                    }}>
                                                                        <i className="ri-delete-bin-5-line me-2  align-bottom text-danger"></i>{t('t-delete')}
                                                                    </DropdownItem>
                                                                </DropdownMenu>
                                                            </UncontrolledDropdown>
                                                        </div>
                                                        <div className="conversation-name">
                                                            <small className="text-muted time">
                                                                {new Date(message['created_time']).toLocaleString('ru').slice(0, 17)}
                                                            </small>
                                                            <span className="text-success check-message-icon"><i
                                                                className="ri-check-double-line align-bottom"></i></span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </li>,
                                        )}
                                    </ul>
                                </SimpleBar>
                            </div>

                            {showCopyAlert && (
                                <div className="px-2 d-flex justify-content-center position-relative">
                                    <Alert color="success" className="mb-2 position-absolute"
                                           style={{
                                               width: "fit-content",
                                               bottom: "4rem",
                                               zIndex: 1050
                                           }}>
                                        {t('t-copied') || 'Nusxa olindi!'}
                                    </Alert>
                                </div>
                            )}

                            <div className="border-top border-top-dashed">
                                <Row className="g-2 mx-3 mt-2 mb-3">
                                    <Col className="col">
                                        <div className="position-relative">
                                            <input type="text" className="form-control border-light bg-light"
                                                   placeholder={t('t-enter-message') + '...'} onKeyUp={onKeyUp}
                                                   onChange={changeHandler} value={text} id="message-input"/>
                                        </div>
                                    </Col>
                                    <Col className="col-auto">
                                        <button type="button" className="btn btn-info" onClick={sendMessage}>
                                            <i className="mdi mdi-send"></i>
                                        </button>
                                    </Col>
                                </Row>
                            </div>
                        </CardBody>
                    </Card>
                </div>
            </div>
        </React.Fragment>
    );
};

export default Chat;